import { axios } from '.';

const countries = async () => {
  const url = `api/countries/`;
  const response = await axios.get(url);
  return response;
};

export { countries };
